import { createRouter } from "@tanstack/react-router";
import { rootRoute } from "@/routes/__root";
import { indexRoute } from "@/routes/index";
import { publicRoute } from "@/routes/public";
import { healthRoute } from "@/routes/health";
import { loginRoute } from "@/routes/login";

const routeTree = rootRoute.addChildren([indexRoute, publicRoute, healthRoute, loginRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
